import React, { useEffect, useState } from "react";
import * as s from "../VideoManagerStyled";
import TableButton from "components/atoms/buttons/TableButton";
import { Tree } from "react-arborist";
import { AiFillFile, AiFillFolder } from "react-icons/ai";
import { MdArrowDropDown, MdArrowRight, MdEdit } from "react-icons/md";
import { videoGuideOptions } from "utils/options";
import {
  SelectGroup,
  VIDEO_GUIDE_TYPE,
} from "api/interfaces/managerInterface.interface";

export type Data = {
  id: string;
  name: string;
  position: number;
  children: Data[];
};

type Props = {
  data: Data[];
  onClickGroup: (id: string) => void;
  onClickEditGroup: (id: string) => void;
  onModal: (type: VIDEO_GUIDE_TYPE, isEdit: boolean) => void;
  treeRef: React.MutableRefObject<any>;
  isGroupAddModal: boolean;
  isGroupEditModal: boolean;
  selectGroup: SelectGroup;
};

export default function VideoSidebarPresenter(props: Props) {
  return (
    <s.LeftAside>
      <s.TreeContainer>
        {(props.data || []).length > 0 &&
          (props.data[0].children || []).length > 0 && (
            <Tree
              data={props.data}
              ref={props.treeRef}
              className={"tree"}
              rowClassName={"row"}
              indent={24}
              rowHeight={36}
              overscanCount={1}
              paddingTop={30}
              paddingBottom={10}
              padding={25}
              onSelect={(nodes) => {
                if (nodes?.[0]?.level === 1) {
                  props.onClickGroup?.(nodes?.[0]?.data?.id || "");
                }
              }}
              openByDefault={true}
              selection={
                props.data?.[0]?.children?.find(
                  (item) => item.id === props.selectGroup.groupId
                )?.id || ""
              }
            >
              {({ node, style, dragHandle }) => (
                <div
                  className={`node-container ${
                    node.state.isSelected ? "isSelected" : ""
                  }`}
                  style={style}
                  ref={dragHandle}
                >
                  <div
                    className="node-content"
                    onClick={() => node.isInternal && node.toggle()}
                    data-testid="manager-video-manager-sidebar-div-toggle"
                  >
                    {node.level === 1 ? (
                      <>
                        <span className="arrow"></span>
                        <span className="file-folder-icon">
                          <AiFillFile color="#6bc7f6" />
                        </span>
                      </>
                    ) : (
                      <>
                        <span className="arrow">
                          {node.isOpen ? <MdArrowDropDown /> : <MdArrowRight />}
                        </span>
                        <span className="file-folder-icon">
                          <AiFillFolder color="#f6cf60" />
                        </span>
                      </>
                    )}

                    <span className="node-text">
                      {node.isEditing ? (
                        <input
                          type="text"
                          defaultValue={node?.data?.name}
                          onFocus={(e) => e.currentTarget.select()}
                          onBlur={() => node.reset()}
                          onKeyDown={(e) => {
                            if (e.key === "Escape") node.reset();
                            if (e.key === "Enter")
                              node.submit(e.currentTarget.value);
                          }}
                          autoFocus
                        />
                      ) : (
                        <span>{node?.data?.name}</span>
                      )}
                    </span>
                  </div>

                  {node.level === 1 && node.isSelected && (
                    <div className="file-actions">
                      <div className="folderFileActions">
                        <button
                          onClick={() => {
                            if (props.onClickEditGroup && node.id) {
                              props.onClickEditGroup(node.id);
                            }
                          }}
                          title="Edit"
                          data-testid="manager-video-manager-sidebar-button-click-edit-group"
                        >
                          <MdEdit />
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              )}
            </Tree>
          )}
      </s.TreeContainer>
    </s.LeftAside>
  );
}
